export function ArrowIcon() {
  return (
    <svg width="9" height="5" viewBox="0 0 9 5" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.85355 4.85355C8.67999 5.02712 8.41056 5.0464 8.21569 4.91141L8.14645 4.85355L4.5 1.207L0.853554 4.85355C0.679987 5.02712 0.410563 5.0464 0.215694 4.91141L0.146446 4.85355C-0.0271206 4.67999 -0.0464048 4.41056 0.0885916 4.21569L0.146446 4.14645L4.14645 0.146447C4.32001 -0.0271196 4.58944 -0.0464048 4.78431 0.0885911L4.85355 0.146447L8.85355 4.14645C9.04882 4.34171 9.04882 4.65829 8.85355 4.85355Z"
        fill="#68737D"
      />
    </svg>
  )
}
